import React from "react";
import PartnerOffers from "./PartnerOffers";

// What organizations can do with Cloud Print, near the bottom of the home page. The
// menu, the logo band under the hero and the footer lead here too, through /partners.

const HomePartners = () => (
  <section className="home-partner-offers section" id="partners" aria-labelledby="home-partner-offers-title">
    <div className="container">
      <div className="home-section-heading has-text-centered">
        <span>ХАМТРАН АЖИЛЛАХ</span>
        <h2 id="home-partner-offers-title">Хамтран ажиллах боломжууд</h2>
        <p>Киоск байршуулах, худалдаж авах, дэлгэцэнд нь рекламаа гаргах хүсэлтээ илгээгээрэй.</p>
      </div>
      <PartnerOffers />
    </div>
  </section>
);

export default HomePartners;
